import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { NewInvoicePage } from '@/pages/invoices/new/NewInvoicePage'

const NewInvoiceSearchSchema = z.object({
  recurring: z.boolean().optional(),
  clientId: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/_dashboard/invoices/new/')({
  validateSearch: NewInvoiceSearchSchema,
  component: NewInvoicePage,
})
